import { create } from 'zustand';
import { onboardingService } from '../services/onboardingService';
import type { OnboardingStatusResponse } from '../types/onboarding';

interface OnboardingReactivationState {
  fetchStatus: () => Promise<OnboardingStatusResponse>;
}

// Action-only: a panel that keys off a refusal keeps its own useState and re-fetches fresh on every
// mount, so there is nothing worth caching here.
export const useOnboardingReactivationStore = create<OnboardingReactivationState>(() => ({
  fetchStatus: () => onboardingService.getStatus(),
}));
